import { TRANFERS_REFRESH_URLS, CRYPTO_REFRESH_URLS } from '../constants/refreshTokenUrlSections';

export const tokenRefreshOnMBCalls = (mbUrl = "") => {
  const urlRefreshList = [
    ...Object.values(TRANFERS_REFRESH_URLS),
    ...Object.values(CRYPTO_REFRESH_URLS),
  ];
  const needRfresh = urlRefreshList.some(urlSection => mbUrl.includes(urlSection));
  return needRfresh;
};
